import {
  Box,
  Grid,
  Typography,
  Hidden,
  IconButton,
  LinearProgress,
  CardMedia,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useHistory } from 'react-router';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/InvestorWithoutPan/contributor';
import {
  AuthorisedSignatories,
  poaApprover,
  RmsType,
  SubDistributorListType,
} from '../../redux-store/types/api-types';
import {
  getAuthorisedSignatoryById,
  getDistributorRMbyId,
  getPoaApproverById,
  getRMById,
} from '../../redux-store/actions/userManagement';
import { Location } from 'history';

export default function PoaApproverDetails({
  location,
}: {
  location: Location<{ poaApproverId: number }>;
}): JSX.Element {
  const { poaApproverId: id } = location.state || { poaApproverId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [poaApproverDetails, setPoaApproverDetailsDetails] = useState<poaApprover>();

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        if (id) {
          const getPoaApproverDetails = (await dispatch(
            getPoaApproverById(id)
          )) as unknown as poaApprover;
          setPoaApproverDetailsDetails(getPoaApproverDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          py: { xs: 2, sm: 5 },
          px: { xs: 0, sm: 5 },
          mt: { xs: 2, sm: 5 },
        }}>
        <Hidden smUp={true}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              onClick={() =>
                history.push('poa-approver', {
                  distributorId: poaApproverDetails?.distributorId,
                })
              }>
              <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 2,
              py: 2,
              pl: { xs: 3, sm: 0 },
              color: 'primary.main',
              bgcolor: 'rgba(238, 244, 251, 0.5)',
            }}>
            <PersonOutlineOutlinedIcon fontSize="large" />
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                pl: 1,
              }}>
              User Management
            </Typography>
          </Box>
        </Hidden>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden only="xs">
              <IconButton
                sx={{ height: 'fit-content', p: 0 }}
                onClick={() =>
                  history.push('poa-approver', {
                    distributorId: poaApproverDetails?.distributorId,
                  })
                }>
                <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
              </IconButton>
            </Hidden>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
                pl: { xs: 2, sm: 0 },
              }}>
              POA Approver
            </Typography>
          </Box>
          <IconButton>
            <CardMedia
              component="img"
              src="/images/edit-icon-outlined.svg"
              alt="Edit Icon"
              sx={{ width: 'unset' }}
              onClick={() =>
                history.push('edit-poaApprover', {
                  poaApproverId: poaApproverDetails?.id,
                })
              }
            />
          </IconButton>
        </Box>
        {isLoading ? (
          <LinearProgress sx={{ ml: 5, mr: 5 }} />
        ) : (
          poaApproverDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'Name'} description={poaApproverDetails.user.firstName} />
                    <KeyValue title={'Email Id'} description={poaApproverDetails.user.email} />
                    <KeyValue
                      title={'Mobile Number'}
                      description={
                        poaApproverDetails.user?.countryCode
                          ? poaApproverDetails.user?.countryCode +
                            '-' +
                            poaApproverDetails.user?.phone
                          : poaApproverDetails.user.phone
                      }
                    />
                    <KeyValue title={'Pan/Tax Id'} description={poaApproverDetails.panNumber} />
                    <KeyValue title={'Pincode'} description={poaApproverDetails.pincode} />
                    <KeyValue
                      title={'Building Number'}
                      description={poaApproverDetails.buildingNo}
                    />
                    <KeyValue title={'Street Name'} description={poaApproverDetails.streetName} />
                    <KeyValue title={'State'} description={poaApproverDetails.state} />
                    <KeyValue title={'City'} description={poaApproverDetails.city} />
                    <KeyValue title={'Country'} description={poaApproverDetails.country} />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
